// ============================================================
// Shared constants — used by both frontend and backend.
// ============================================================
export const ISSUE_SEVERITY_LABELS = {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    critical: 'Critical',
};
export const UPLOAD_TYPE_LABELS = {
    recording: 'Recording',
    syslog: 'System Log',
};
export const UPLOAD_STATUS_LABELS = {
    pending: 'Uploading',
    complete: 'Complete',
    failed: 'Failed',
    expired: 'Expired',
};
// Max file sizes — must match backend enforcement
export const MAX_RECORDING_SIZE_BYTES = 100 * 1024 * 1024; // 100 MB
export const MAX_SYSLOG_SIZE_BYTES = 5 * 1024 * 1024 * 1024; // 5 GB
// Allowed MIME types per upload type
export const ALLOWED_RECORDING_MIME_TYPES = [
    'video/mp4',
    'video/webm',
    'video/quicktime',
    'audio/mpeg',
    'audio/wav',
];
export const ALLOWED_SYSLOG_MIME_TYPES = [
    'text/plain',
    'application/gzip',
    'application/x-gzip',
    'application/zip',
    'application/x-tar',
];
// Keycloak roles
export const ROLE_CUSTOMER = 'customer';
export const ROLE_ADMIN = 'admin';
// Gitea label prefix for customer-submitted issues
export const GITEA_CUSTOMER_LABEL_PREFIX = 'customer:';
// Default per-file cap for issue attachments (50 MB). Mirrors the backend's
// ATTACHMENT_MAX_BYTES default; used client-side for instant feedback before
// upload. The server remains authoritative — a passing soft check doesn't
// guarantee the upload will succeed.
export const DEFAULT_ATTACHMENT_MAX_BYTES = 52_428_800;
//# sourceMappingURL=index.js.map